(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('notificationCenter', notificationCenter)
        .directive("whenScrolled", function () {
            return function (scope, elm, attr) {
                var raw = elm[0];
                elm.bind('scroll', function () {
                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                        scope.$apply(attr.whenScrolled);
                    }
                });
            };
        })
        .filter('notificationType', function () {
            return function (notifications, type, onlyUnread) {
                if (notifications)
                    switch (type) {
                        case -1:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 : n.key !== 50);
                        case 60:
                        case 70:
                        case 80:
                        case 90:
                        case 100:
                        case 110:
                        case 120:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 &&
                                (n.key === 60 || n.key === 70 || n.key === 80 || n.key === 90 || n.key === 100 || n.key === 110 ||
                                    n.key === 120) :
                                n.key !== 50 &&
                                (n.key === 60 || n.key === 70 || n.key === 80 || n.key === 90 || n.key === 100 || n.key === 110 ||
                                    n.key === 120));
                        default:
                            return notifications.filter(n => onlyUnread ? !n.isRead && n.key !== 50 && n.key === type :
                                n.key !== 50 && n.key === type);
                    }
            };
        });

    function notificationCenter() {
        var directive = {
            templateUrl: '/app/common/notification-center.html',
            scope: {
                input: '=',
                toggle: '=',
                isvisible: '='
            },
            restrict: 'EA',
            controller: notificationCenterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;

    }

    notificationCenterController.$inject = ['$scope', 'notificationService', 'userSvc', '$state', '$rootScope',
        '$window', '$timeout', '$interval'];
    function notificationCenterController($scope, notificationService, userSvc, $state, $rootScope,
        $window, $timeout, $interval) {
        var vm = this;
        vm.notifications = notificationService.notifications;
        vm.onlyUnread = false;

        vm.selectedTabId = -1;
        vm.changeTab = function (tabId) {
            vm.selectedTabId = tabId;

            // When switching to Beamer tab (80), apply dark mode if needed
            if (tabId === 80) {
                $timeout(function () {
                    applyBeamerDarkMode();
                }, 500);
            }
        };
        notificationService.params.page = 1;

        // Function to inject dark mode CSS into Beamer iframe
        function applyBeamerDarkMode() {
            var isDarkMode = localStorage.getItem('darkMode') === 'true';
            if (!isDarkMode) return;

            var beamerIframe = document.querySelector('.beamer-panel iframe');
            if (!beamerIframe) {
                // Retry if iframe not loaded yet
                var retryCount = 0;
                var retryInterval = $interval(function () {
                    beamerIframe = document.querySelector('.beamer-panel iframe');
                    retryCount++;

                    if (beamerIframe || retryCount > 10) {
                        $interval.cancel(retryInterval);
                        if (beamerIframe) {
                            injectDarkModeCSS(beamerIframe);
                        }
                    }
                }, 200);
                return;
            }

            injectDarkModeCSS(beamerIframe);
        }

        function injectDarkModeCSS(iframe) {
            try {
                var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                if (!iframeDoc) return;

                // Check if CSS already injected
                if (iframeDoc.getElementById('endeksa-dark-mode-injection')) return;

                var style = iframeDoc.createElement('style');
                style.id = 'endeksa-dark-mode-injection';
                style.textContent = `
                    /* Endeksa Dark Mode Injection for Beamer */
                    body {
                        background-color: #1e1e1e !important;
                        color: #ccc !important;
                    }

                    /* Headers */
                    h1, h2, h3, h4, h5, h6 {
                        color: #fff !important;
                    }

                    /* Cards/Posts */
                    .post, .beamer-post, [class*="post"] {
                        background-color: #2a2a2a !important;
                        border-color: rgba(80, 80, 80, 0.3) !important;
                    }

                    /* Links */
                    a {
                        color: #58B1FF !important;
                    }

                    /* Buttons */
                    button, .button {
                        background-color: #3a3a3a !important;
                        color: #fff !important;
                        border-color: rgba(80, 80, 80, 0.5) !important;
                    }

                    /* Input fields */
                    input, textarea, select {
                        background-color: #1a1a1a !important;
                        color: #ccc !important;
                        border-color: rgba(80, 80, 80, 0.5) !important;
                    }

                    /* Scrollbar */
                    ::-webkit-scrollbar-thumb {
                        background: rgba(255, 255, 255, 0.2) !important;
                    }

                    ::-webkit-scrollbar-track {
                        background: rgba(0, 0, 0, 0.2) !important;
                    }
                `;

                iframeDoc.head.appendChild(style);
                console.log('Beamer dark mode CSS injected successfully');
            } catch (e) {
                // Cross-origin iframe - can't inject CSS
                console.warn('Cannot inject CSS into Beamer iframe (cross-origin):', e);
            }
        }

        // Listen for dark mode changes
        $scope.$on('darkMode:changed', function (event, data) {
            if (vm.selectedTabId === 80) {
                if (data.enabled) {
                    applyBeamerDarkMode();
                } else {
                    // Remove injected CSS
                    var beamerIframe = document.querySelector('.beamer-panel iframe');
                    if (beamerIframe) {
                        try {
                            var iframeDoc = beamerIframe.contentDocument || beamerIframe.contentWindow.document;
                            var injectedStyle = iframeDoc.getElementById('endeksa-dark-mode-injection');
                            if (injectedStyle) {
                                injectedStyle.remove();
                            }
                        } catch (e) {
                            console.warn('Cannot remove CSS from Beamer iframe:', e);
                        }
                    }
                }
            }
        });

        $scope.$on('nc_visible', function () {
            if (userSvc.info.Id) {
                vm.signedIn = true;
                notificationService.params.page = 1;
                notificationService.getNotifications();
            } else {
                vm.signedIn = false;
                vm.selectedTabId = 80;
            }
        });

        $scope.$on('nc_visible_80', function () {
            vm.selectedTabId = 80;
        });

        vm.loadMore = function () {
            notificationService.params.page++;
            notificationService.list({ page: notificationService.params.page, itemsPerPage: notificationService.params.itemsPerPage }).then(function (result) {
                let notifications = result.map(function (n) {
                    let utc = new Date(n.createdDate);
                    var offset = utc.getTimezoneOffset($rootScope.lang);
                    var local = new Date(utc.getTime() - offset * 60000);
                    n.createdDate = local;
                    return n;
                });
                notificationService.notifications = notificationService.notifications.concat(notifications);
                vm.notifications = notificationService.notifications;
            });
        };

        vm.goToProfile = function () {
            $state.go('profile.company', { langcode: window.lang });
            vm.toggle();
        };

        vm.redirect = function (notification) {
            if (!notification.isRead)
                notificationService.read(notification);

            let agentName;
            switch (notification.key) {
                case 10:
                    $state.go('blogDetail', { name: notification.value, refresh: true, langcode: $window.lang }, { reload: true });
                    break;
                case 20:
                    $state.go("analysis.country.alarm", { idm: notification.value, langcode: $window.lang, country: 'world' }, { reload: true });
                    break;
                case 40:
                    let user = userSvc.info;
                    agentName = $rootScope.agentAddress(user);
                    $state.go("agent-detail", { langcode: $window.lang, id: user.Id, name: agentName });
                    break;
                case 60:
                case 80:
                case 100:
                case 110:
                case 120:
                    $state.go("lead", { langcode: $window.lang, id: notification.value });
                    break;
                case 130:
                    let propertyValue = JSON.parse(notification.value);
                    $state.go("property-detail",
                        {
                            langcode: $window.lang,
                            id: propertyValue.PropertyId,
                            name: $rootScope.normalizeAddress(propertyValue.PropertyTitle)
                        });
                    break;
                case 70:
                case 90:
                    let value = JSON.parse(notification.value);
                    agentName = $rootScope.agentAddress({ Details: { profile: { name: value.AgentName, surName: value.AgentSurname } } });
                    $state.go("agent-detail", { langcode: $window.lang, id: value.AgentId, name: agentName });
                    break;

                case 300:
                    $state.go("order-payment", { orderId: $rootScope.upcomingPayment.paymentOrderId, paymentPrice: $rootScope.upcomingPayment.unpaidPrice });
                    break;

            }
            vm.toggle();
        };

        vm.readAll = function () {
            notificationService.readAll();
        };

    }
})();
